import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable } from 'rxjs';
import { ZissonInteractCategoryChangesResult } from '../../core/models/zisson-interact-category-changes-result.model';
import { ZissonInteractCategoryChangeResult } from '../../core/models/zisson-interact-category-change-result.model';

@Injectable({ providedIn: 'root' })
export class ZissonInteractService {
    constructor(private httpClient: HttpClient) {}

    getCategoryChangesStatus(ticketIds: number[]): Observable<ZissonInteractCategoryChangesResult> {
        return this.httpClient.post<ZissonInteractCategoryChangesResult>(
            environment.apiInboxUrl + 'ZissonInteract/CategoryChangesStatus',
            ticketIds,
        );
    }

    getCategoryChangeStatus(ticketId: number): Observable<ZissonInteractCategoryChangeResult> {
        return this.httpClient.get<ZissonInteractCategoryChangeResult>(
            environment.apiInboxUrl + 'ZissonInteract/CategoryChangeStatus',
            { params: { ticketId } },
        );
    }
}
